import React from 'react';
import styles from './action-card.module.css';
import classNames from 'classnames';
import { Anchor } from '../../buttons';
export function ActionCard(_a) {
    var actionText = _a.actionText, description = _a.description, icon = _a.icon, onClick = _a.onClick, title = _a.title;
    return (React.createElement("div", { className: classNames('card', styles.actionCardWrapper, "kplr_actionCardWrapper"), onClick: onClick },
        React.createElement("div", { className: styles.actionCardInner },
            React.createElement("div", { className: styles.actionCardIcon }, typeof icon === 'string' ? (React.createElement(React.Fragment, null,
                React.createElement("object", { data: icon, type: "image/svg+xml" },
                    React.createElement("img", { src: icon, alt: "" })))) : (React.createElement(React.Fragment, null, icon()))),
            React.createElement("div", { className: styles.actionCardContent },
                React.createElement("h3", { className: "heading3" }, title),
                React.createElement("p", { className: "body2" }, description)),
            React.createElement("div", { className: styles.actionCardAction },
                React.createElement(Anchor, { arrow: true, "aria-hidden": "true" }, actionText)))));
}
export default ActionCard;
